<script setup lang="ts">
import { computed } from 'vue';
import { ThemeInstance, useTheme } from 'vuetify';
import { THEME_NAMES } from '../vueify';

const theme: ThemeInstance = useTheme();

const toggleTheme = (): void => {
    const isAdminTheme = currentTheme.value === THEME_NAMES.ADMIN_LIGHT || currentTheme.value === THEME_NAMES.ADMIN_DARK;
    if (isAdminTheme) {
        theme.global.name.value = theme.global.current.value.dark ? THEME_NAMES.ADMIN_LIGHT : THEME_NAMES.ADMIN_DARK
        return;
    }

    theme.global.name.value = theme.global.current.value.dark ? THEME_NAMES.LIGHT : THEME_NAMES.DARK
}

const currentTheme = computed<string>({
    get() {
        return theme.global.name.value
    },
    set(newValue) {
        theme.global.name.value = newValue
    }
})

const icon = computed<string>(() => {
    if (!theme.global.current.value.dark)
        return 'mdi-weather-night'
    else
        return 'mdi-weather-sunny'
})

</script>
<template>
    <v-fab :icon="icon" @click="toggleTheme" class="fab"></v-fab>
</template>

<style>
.fab {
    position: fixed;
    bottom: 15px;
    right: 15px;
}
</style>
